import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

const SESSION_KEY = "tmr-intro-seen";
const AUTO_DISMISS_MS = 2600;
const DISMISS_EVENTS = ["wheel", "touchmove", "keydown", "pointerdown"];

export default function SplashIntro() {
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(() => !sessionStorage.getItem(SESSION_KEY));

  useEffect(() => {
    if (!visible) return;
    const dismiss = () => {
      sessionStorage.setItem(SESSION_KEY, "1");
      setVisible(false);
    };
    const timer = setTimeout(dismiss, reduceMotion ? 1200 : AUTO_DISMISS_MS);
    DISMISS_EVENTS.forEach((e) => window.addEventListener(e, dismiss, { passive: true }));
    return () => {
      clearTimeout(timer);
      DISMISS_EVENTS.forEach((e) => window.removeEventListener(e, dismiss));
    };
  }, [visible, reduceMotion]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="splash"
          data-testid="splash-intro"
          role="presentation"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-primary"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: reduceMotion ? 0.2 : 0.8, ease: "easeInOut" } }}
        >
          <div className="absolute inset-0 grain" />
          <motion.img
            src="/logo.png"
            alt="Tenorio Master Roofing"
            data-testid="splash-logo"
            className="relative w-[78vw] max-w-[640px] md:w-[46vw] h-auto rounded-xl shadow-2xl ring-1 ring-white/15"
            initial={reduceMotion ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.86 }}
            animate={{ opacity: 1, scale: 1, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } }}
            exit={{ scale: 1.08, opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
          />
          <motion.span
            className="absolute bottom-10 md:bottom-14 font-display font-bold text-[11px] md:text-xs tracking-[0.3em] uppercase text-white/60"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0, transition: { delay: 0.7, duration: 0.6 } }}
          >
            Tenorio Master Roofing · West Covina, CA
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
